import { messaging, getFcmToken, onMessage } from './firebaseConfig';

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;
const API_URL = process.env.REACT_APP_API_URL;
const DEVICE_ID_KEY = 'web_push_device_id';

function getOrCreateDeviceId() {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = 'web_' + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2) + Date.now().toString(36));
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

/**
 * Register service worker and get FCM token, then send it to the backend.
 * Returns the FCM token on success, null otherwise.
 */
export async function registerWebPush(authToken) {
  if (!messaging || !VAPID_KEY || !authToken) return null;

  try {
    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    // Register the service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    // Get FCM token
    const fcmToken = await getFcmToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (!fcmToken) return null;

    const deviceId = getOrCreateDeviceId();

    // Send FCM token to backend
    await fetch(`${API_URL}/api/user/updatefcmToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({ fcmToken, deviceId }),
    });

    return fcmToken;
  } catch (e) {
    // Web push registration failed silently
    return null;
  }
}

/**
 * Listen for foreground FCM messages. Returns an unsubscribe function.
 */
export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}
